import React, { memo, useEffect } from 'react';
import { Buttons, Loader } from 'components';
import { manageAppsAPI } from 'services/manageApps.service';
import { polipop } from 'constants';

const TestBtn = ({ previewURL, disabled }) => {
  const [testAction, result] = manageAppsAPI.useCheckPostbackUrlMutation();

  const handleClick = () => {
    testAction(previewURL);
  };

  useEffect(() => {
    if (result.isSuccess) {
      polipop.add({
        content: 'Postback URL correct',
        title: 'Success',
        type: 'success',
      });
    }
    if (result.error) {
      polipop.add({
        content: 'Postback URL not correct',
        title: 'Error',
        type: 'error',
      });
    }
  }, [result]);

  return (
    <>
      {result.isLoading && <Loader.Global />}
      <Buttons.SecondaryNormal isDisabled={disabled} id='testBtn' onClick={handleClick}>
        Test
      </Buttons.SecondaryNormal>
    </>
  );
};

export default memo(TestBtn);
